import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { GlobalContext, formatDateMDY } from '../../../utility'
import { ANALYTICS_PAGE_VIEW, sendAnalyticsPageview } from '../../../analytics'

export function MetaDataCompound({
  ctiBlogArticleSummary,
  lastFourDigitsOfWorkfront,
}) {
  const {
    breadcrumbs: breadcrumbsFromGlobalContext,
    contentTags: contentTagsFromGlobalContext,
    contentTagsLoaded,
  } = useContext(GlobalContext)
  const [sendAnalytics, setSendAnalytics] = useState(true)
  const {
    bannerSummary,
    cardSummary,
    metadataCompound: metaDataCompound,
    backgroundImageUrl,
  } = ctiBlogArticleSummary
  const keywords = metaDataCompound.keywords

  const metaTitle = metaDataCompound.title || ctiBlogArticleSummary.title
  const omniTitle = metaDataCompound.omniTitle || ctiBlogArticleSummary.title
  const ogTitle = metaDataCompound.ogtitle || ctiBlogArticleSummary.title

  const ogDescription =
    metaDataCompound.ogDescription || bannerSummary || cardSummary
  const omniDescription =
    metaDataCompound.omniDescription || bannerSummary || cardSummary
  const description =
    metaDataCompound.description || bannerSummary || cardSummary
  const omniCategory =
    metaDataCompound.omniCategory || bannerSummary || cardSummary
  const socialImage =
    metaDataCompound.socialImage?.imageUrl || backgroundImageUrl
  const isoSplit = new Date(ctiBlogArticleSummary.publicationDate)
    .toISOString()
    .split('T')
  const publishedTime = `${isoSplit[0]} ${isoSplit[1].split('.')[0]}`
  const publicationNames = ctiBlogArticleSummary.types?.join(' ')
  const _publicationDate = formatDateMDY(ctiBlogArticleSummary.publicationDate)

  window.digitalData = {
    ...window.digitalData,
    page: {
      ...window.digitalData?.page,
      pageInfo: {
        ...window.digitalData?.page?.pageInfo,
        pageName: metaTitle,
        destinationURL: window.location.href,
        breadCrumbs: ['Home'].concat(
          breadcrumbsFromGlobalContext?.payload?.map((b) => b.name) || []
        ),
        publicationDate: _publicationDate,
        language: 'en-us',
        geoRegion: 'US',
        contentTags: contentTagsFromGlobalContext?.payload || [],
        lastFourDigitsOfWorkfront: lastFourDigitsOfWorkfront || null,
      },
      attributes: {
        siteName: 'ctius',
        dataLayerType: 'dynamic',
      },
    },
    version: '1.0',
  }

  if (document?.payload?.publicationDate) {
    window.digitalData.page.pageInfo.publicationDate = new Date(
      document?.payload?.publicationDate
    ).toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  useEffect(() => {
    if (
      window.digitalData.page.pageInfo.breadCrumbs.length === 4 &&
      contentTagsLoaded &&
      sendAnalytics
    ) {
      setSendAnalytics(false)
      sendAnalyticsPageview(ANALYTICS_PAGE_VIEW)
    }
  })

  return (
    <Helmet defer={false}>
      {metaTitle && <meta name="title" content={`${metaTitle}`} />}
      {description && <meta name="description" content={description} />}
      {omniTitle && <meta name="omni_title" content={omniTitle} />}
      {omniDescription && (
        <meta name="omni_description" content={omniDescription} />
      )}
      {omniCategory && <meta name="omni_category" content={omniCategory} />}
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogDescription && (
        <meta property="og:description" content={ogDescription} />
      )}
      {socialImage && <meta property="og:image" content={socialImage} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {publicationNames && (
        <meta property="article:publication_names" content={publicationNames} />
      )}
    </Helmet>
  )
}

MetaDataCompound.propTypes = {
  ctiBlogArticleSummary: PropTypes.object,
  lastFourDigitsOfWorkfront: PropTypes.string,
}
